import commonApp from "../store/modules/app";
import base from "@/store/modules/base";
export default {
  install: function (Vue) {
    Vue.prototype.$localMark = {
      lang: process.env.lang, // zh-CN
      countryCode: process.env.countryCode, // +86
      get currency() {
        return base.state.serverStateInfo.currencyUnit || ""; // 元
      },
      get currencySymbol() {
        return base.state.serverStateInfo.currencySymbol || ""; // ￥ process.env.currencySymbol
      },
      get currencyBrackets() {
        return commonApp.state.lang === "zh-CN" && base.state.serverStateInfo.currencyUnit
          ? `(${base.state.serverStateInfo.currencyUnit})`
          : `(${base.state.serverStateInfo.currencyUnit})`;
      }
    };
  }
};
